import CbCol from './src/col.vue';

CbCol.install = function(Vue) {
  Vue.component(CbCol.name, CbCol);
};

export default CbCol;
